import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-on-prem',
  templateUrl: './on-prem.component.html',
  styleUrls: ['./on-prem.component.scss']
})
export class OnPremComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
